import { ReactNode } from 'react';
import cn from 'classnames';
import { TabList as ReakitTabList, TabOptions } from 'reakit/Tab';

interface TabListProps {
  className?: string;
  children?: ReactNode;
  tab: TabOptions;
  withBottomBorder?: boolean;
}

export default function TabList({
  children,
  tab,
  withBottomBorder,
  className,
  ...rest
}: TabListProps) {
  return (
    <ReakitTabList
      {...tab}
      className={cn(
        `relative flex w-full overflow-hidden lg:overflow-hidden`,
        className,
      )}
      {...rest}
    >
      <div
        className={cn(
          `scrolling-touch absolute top-0 right-0 left-0 bottom-0 h-full w-auto overflow-y-hidden overflow-x-scroll whitespace-nowrap lg:relative lg:overflow-x-hidden`,
          {
            'shadow-none md:shadow-border': withBottomBorder,
          },
        )}
      >
        {children}
      </div>
    </ReakitTabList>
  );
}
